import React from 'react';
import { useRouter } from 'next/router';
import { omitBy, isNil } from 'lodash';
import { BoardBasisSearch } from '@model/common';
import { DestinationLinkBuilder, LinkItem } from '@model/iceberg';
import { HotelTile } from '@model/iceberg/hotel-content/hotel-content';
import { DealFinderTile } from '@components/common/deal-finder-tile/DealFinderTile';

export interface FromPriceByPathProductTileProps {
  testFlag?: boolean;
  testId?: string;
  className?: string;
  productPackage: HotelTile;
  deepLink?: boolean;
}

export const FromPriceByPathProductTile = ({ productPackage, deepLink }: FromPriceByPathProductTileProps) => {
  if (!productPackage) return null;

  const router = useRouter();
  const {
    price,
    place,
    adults,
    airport,
    checkInDate,
    nights,
    boardBasis,
    hotelRating,
    tripAdvisorRating,
    gallery,
    featuredImage
  } = productPackage;
  const cheapestPrice: number = price.amount;
  const linkBuilder: DestinationLinkBuilder = new DestinationLinkBuilder();
  const [year, month] = checkInDate ? checkInDate.split('-') : [];
  const searchParams = deepLink
    ? omitBy(
        { adults, from: airport?.code, year, month, boardBasis: BoardBasisSearch[boardBasis], duration: nights },
        isNil
      )
    : undefined;
  const link: LinkItem = linkBuilder.getDestinationLink(place.hotel!.path, undefined, undefined, searchParams);
  const handleOnClick = () => router.push(link.as);

  return (
    <DealFinderTile
      onClick={handleOnClick}
      result={{
        leadInPrice: {
          mealPlan: boardBasis,
          packageReferences: [],
          perPerson: {
            amount: cheapestPrice,
            currency: price.currency
          },
          total: {
            amount: cheapestPrice,
            currency: price.currency
          }
        },
        summary: {
          place,
          startDate: checkInDate,
          nights,
          hotelRating: Number(hotelRating),
          tripAdvisorRating,
          gallery,
          featuredImage,
          connectId: 0
        },
        otherPrices: []
      }}
    />
  );
};
